<template>
  <div>
    <timesheet-field :layout="fieldSelectorDropdownLayout" @change="onChange" :showAddButton="true" @addClick="showFieldFromSelector" />
    <timesheet-fieldset v-for="(field, index) in enabledFields" :key="index" :layout="field" @change="onChange" />
  </div>
</template>

<script>
  import TimesheetField from '../field/TimesheetField.vue';
  import TimesheetFieldset from '../TimesheetFieldset.vue'
  export default {
    components: { 
      TimesheetFieldset: () => import('../TimesheetFieldset.vue'),
      TimesheetField 
    },
    name: "timesheet-group-field-selector",
    props: {
      layout: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        layoutData: this.layout,
        fieldSelectorDropdownLayout: {
          label: this.layout.label,
          type: "dropdown",
          options: [],
          value: 0
        }
      }
    },
    computed: {
      enabledFields() {
        return this.layoutData.fields.filter(e => e.enabled !== false); 
      },
    },
    created () {
      let fieldOptions = [];
      for (const fieldIx in this.layoutData.fields) {
        let field = this.layoutData.fields[fieldIx];
        fieldOptions.push({
          label: field.label,
          value: fieldIx
        })
      }
      this.$set(this.fieldSelectorDropdownLayout, 'options', fieldOptions);
    },
    methods: {
      onChange(e,l,v,i) {
        this.$emit("change", e, l, v, i)
      },
      showFieldFromSelector(e,l,i) {
        this.layoutData.fields[l.value].enabled = true;
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>